import {
    Sidebar,
    SidebarContent,
    SidebarGroup,
    SidebarGroupContent,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
} from "@/components/ui/sidebar";
import { interactionModalSteps } from "../../lib/utils";
import { useInteractions } from "../../hooks/interactionsProvider";
import { VideoInteractionType } from "@yedalabs/schema";
import { t } from "@/lib/localization";

export default function InteractionModalSidebar() {
    const { currentStep, moveToStep, selectedInteraction, step1Label } =
        useInteractions();

    return (
        <Sidebar collapsible="none" className="flex border-e">
            <SidebarContent>
                <SidebarGroup>
                    <SidebarGroupContent>
                        <SidebarMenu>
                            {interactionModalSteps
                                .filter((item) => {
                                    if (
                                        !selectedInteraction ||
                                        !item.showForTypes
                                    ) {
                                        return true;
                                    } else if (
                                        !item.showForTypes.includes(
                                            selectedInteraction.type
                                        )
                                    ) {
                                        return false;
                                    } else {
                                        return true;
                                    }
                                })
                                .map((item) => {
                                    // Step 1's label is provider-supplied so it
                                    // can differ between videoSheet and
                                    // lomdaV2 modes.
                                    const labelKeyName =
                                        item.id === "time-and-type"
                                            ? step1Label.keyName
                                            : item.uniqueTextPerType?.[
                                                  selectedInteraction?.type as VideoInteractionType
                                              ]?.keyName || item.keyName;
                                    return (
                                        <SidebarMenuItem key={item.id}>
                                            <SidebarMenuButton
                                                asChild
                                                isActive={
                                                    item.id === currentStep
                                                }
                                            >
                                                <button
                                                    className="text-start"
                                                    onClick={() =>
                                                        moveToStep(item.id)
                                                    }
                                                >
                                                    <item.icon />
                                                    {t(
                                                        labelKeyName,
                                                        undefined,
                                                        undefined
                                                    )}
                                                </button>
                                            </SidebarMenuButton>
                                        </SidebarMenuItem>
                                    );
                                })}
                        </SidebarMenu>
                    </SidebarGroupContent>
                </SidebarGroup>
            </SidebarContent>
        </Sidebar>
    );
}
